import React, { lazy } from "react";
import { Route, Routes } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";

// Lazy-loaded components
const Home = lazy(() => import("../components/Home/home"));
const About = lazy(() => import("../components/About/About"));
const ContactUsPage = lazy(() => import("../pages/ContactUsPage"));
const CartPage = lazy(() => import("../pages/CartPage"));
const LoginPage = lazy(() => import("../pages/LoginPage"));
const TermsConditionsPage = lazy(() => import("../pages/TermsConditionsPage"));
const HelpSupportPage = lazy(() => import("../pages/HelpSupportPage"));
const PrivacyPolicyPage = lazy(() => import("../pages/PrivacyPolicyPage"));
const RefundPolicyPage = lazy(() => import("../pages/RefundPolicyPage"));
const FaqPage = lazy(() => import("../pages/FaqPage"));
const Dashboard = lazy(() => import("../components/Dashboard/Dashboard"));
const CourseLearningPage = lazy(() => import("../pages/CourseLearningPage"));
const MyProfilePage = lazy(() => import("../pages/MyProfilePage"));
const BillingSectionPage = lazy(() => import("../pages/BillingSectionPage"));
const OrderDetailsPage = lazy(() => import("../pages/OrderDetailsPage"));
const JavaCoursePage = lazy(() => import("../pages/CourseDetailsPage"));

const AppRoutes = () => {
	return (
		<Routes>
			{/* Public Routes */}
			<Route path="/" element={<Home />} />
			<Route path="/LoginPage" element={<LoginPage />} />

			{/* <Route
				path="/"
				element={
					<ProtectedRoute>
						<Home />
					</ProtectedRoute>
				}
			/> */}

			<Route path="/about" element={<About />} />
			<Route path="/ContactUsPage" element={<ContactUsPage />} />
			<Route path="/TermsConditionsPage" element={<TermsConditionsPage />} />
			<Route path="/Help&SupportPage" element={<HelpSupportPage />} />
			<Route path="/PrivacyPolicyPage" element={<PrivacyPolicyPage />} />
			<Route path="/RefundPolicyPage" element={<RefundPolicyPage />} />
			<Route path="/FaqPage" element={<FaqPage />} />
			<Route path="/CartPage" element={<CartPage />} />
			<Route path="/CartPage/:uuid" element={<CartPage />} />
			<Route path="/CourseDetailsPage/:uuid" element={<JavaCoursePage />} />

			{/* Protected Routes */}
			<Route
				path="/Dashboard"
				element={
					<ProtectedRoute>
						<Dashboard />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/CourseLearningPage/:uuid"
				element={
					<ProtectedRoute>
						<CourseLearningPage />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/MyProfilePage"
				element={
					<ProtectedRoute>
						<MyProfilePage />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/BillingSectionPage"
				element={
					<ProtectedRoute>
						<BillingSectionPage />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/OrderDetailsPage"
				element={
					<ProtectedRoute>
						<OrderDetailsPage />
					</ProtectedRoute>
				}
			/>
		</Routes>
	);
};

export default AppRoutes;
